export interface DemoIntegrationOption {
  value: string;
  label: string;
}

export const DEFAULT_DEMO_INTEGRATION_OPTIONS: DemoIntegrationOption[] = [{ value: 'none', label: 'None' }];

export const getDemoIntegrationLabel = (integration: string, options: DemoIntegrationOption[] = []) => {
  const option = options.find(({ value }) => value === integration);

  if (option) {
    return option.label;
  }

  if (!integration || integration === 'none') {
    return 'None';
  }

  return integration
    .split('_')
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
    .join(' ');
};
